const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Resolve an image URL. If it's a relative path (starts with /api/),
 * prepend the backend URL. Otherwise return as-is (external URLs like unsplash).
 */
export function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${API_URL}${url}`;
  return url;
}
